import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DropdownCoordinatorService {
  openDropdown = new Subject<string>();

  notifyDropdownOpened(dropdownId: string): void {
    this.openDropdown.next(dropdownId);
  }
}
